<template>
  <div class="yk-listPage">
    <yk-breadcrumb class="ykbread" :typeName="typeName" type="news"></yk-breadcrumb>
    <div class="listContent">
      <div class="contentLeft">
        <div class="title">{{infoData.title}}</div>
        <div class="information">
          <div class="time">发布时间<span>{{infoData.pubishTime}}</span></div>
          <div class="textKey">文章关键词： <span>{{infoData.keywords}}</span></div>
        </div>
        <div class="code">{{infoData.summarys}}</div>
        <div class="textContent" v-html="infoData.content"></div>
        <div class="goTop" @click="clickGoTop()">返回顶部</div>
      </div>
      <div class="contentRight">
        <div class="title">相关新闻</div>
        <div class="listBox">
          <div class="list" v-for="(item,index) in dataList" :key="index+'data'" @click="clickRelated(item)">
            <div class="imgBox">              
              <img :src="item.pic" alt="" />
            </div>
            <div class="name">{{item.title}}</div>
            <div class="value">{{item.summarys}}</div>
            <div class="value2">{{item.value2}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ykBreadcrumb from '../../components/base/breadcrumb.vue'
export default {
  data () {
    return {
      infoData: {},
      dataList: [],
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      console.log(this.$route.query.newsId);
      if (this.$route.query && this.$route.query.newsId) {
        this.$get(`/api/news/detail/${this.$route.query.newsId}`).then(res => {
          console.log(res);
          if (res.code === 0) {
            this.infoData = res.data
          }
        })
        this.$post(`/api/news/related`, {
          newsId: this.$route.query.newsId
        }).then(res => {
          if (res.code === 0) {
            this.dataList = res.data
          }
        })
      }
    },
    clickRelated (item) {
      let routeUrl = this.$router.resolve({
        path: '/newsDetail',
        query: {newsId: item.id}
      })
      window.open(routeUrl.href, '_self')
    },
    clickGoTop() {
      $('html, body').stop().animate({
        scrollTop: 0
      })
    },
    clickGoBack(){
      this.$router.go(-1);
    }
  },
  beforeDestroy () {
  },
  components: {ykBreadcrumb},
  computed: {
    typeName () {
      let typeList = this.bannerList.find(val => {return val.typeLabel === 'news'})
      if (typeList) {
        let obj = typeList.child.find(val => {return val.id == this.$route.query.navigationId})
        if (obj) {
          return obj.name
        }
      }   
    }
  },
}
</script>

<style scoped lang="stylus">
.yk-listPage
  width 100%
  color $c1
  .banner
    height 627px
    background-color #F1F1F5
    .bannerContent
      width $pageWidth
      height 100%
      margin 0 auto
      position relative
      .f1
        font-size 38px
        padding 80px 0 20px 0
      .f2
        height: 60px
        font-size 50px
        font-weight 600
        line-height 60px
      .more
        width 400px
        display flex
        margin-top 30px
        font-size 25px
        line-height 30px
        .item
          display flex
          cursor pointer
          &:nth-of-type(1)
            margin-right 40px
          .btn
            width 60px
            height 30px
            text-align center
            border 2px solid $c1
            border-radius 50px
            line-height 30px
            margin 0 5px
  .listContent
    display: flex
    justify-content: space-between
    width $pageWidth
    margin: 33px auto 0
    height auto
    .contentLeft
      width 955px
      padding-top 33px
      .title
        font-size: 30px
        color: #202020
        margin-bottom: 35px
      .information
        display: flex
        justify-content: space-between
        width 100%
        margin-bottom: 79px
        .time,.textKey
          font-size: 18px
          color: #999999
        .time
          span
            margin-left: 20px
      .code,.textContent
        font-size: 18px
        color: #202020
        line-height: 36px
        text-align: justify
      .code
        margin-bottom: 50px
      img
        width 860px
        height auto
        margin: 42px 0 30px
      .imgValue
        font-size: 18px
        color: #202020
        line-height: 36px
        text-align: justify
      .goTop
        text-align: right
        margin: 111px 0 60px
        padding-right 17px
        font-size: 18px
        color: #202020
        line-height: 36px
        cursor pointer
    .contentRight
      width 428px
      padding-top 33px
      padding-left 25px
      border-left: 1px solid #EDEDED
      .title
        font-size: 30px
        color: #202020
        padding-bottom: 18px
        border-bottom: 1px solid #EDEDED
      .listBox
        width 100%
        .list
          cursor pointer
          margin-top: 39px
          &:nth-child(1)
            margin-top: 23px
          .imgBox
            width 100%
            height 230px
            background: #EDEDED
            position relative
            overflow hidden
            img
              position absolute
              top 0
              left 0
              bottom 0
              right 0
              margin auto
              width 100%
          .name
            font-size: 18px
            color: #202020
            margin: 22px 0 15px
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          .value,.value2
            font-size: 16px
            color: #999999
            line-height: 20px
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
@media screen and (max-width: 900px)
  .yk-listPage
    .banner
      background-color #E5EBF1
      .bannerContent
        display: none
        width 100%
        .f1
          margin-left 1rem
          font-size 1.3rem
        .f2
          margin-left 1rem
          font-size 1.6rem      
          line-height 2rem 
    .listContent
      width 94%
      margin 1.5rem 3%
      .contentLeft
        width 100%
        padding-top 0
        .title
          font-size: 1.12rem
          color: #202020
          line-height: 1.3333rem
          text-align: justify
          margin: 1.5467rem 0 1.3067rem
        .information
          display: flex
          flex-direction: column
          margin-bottom: 2.1067rem
          .time,.textKey
            font-size: .7rem
          .textKey
            margin-top: .5333rem
        .code,.textContent
          font-size: .7rem
          line-height: 1.2rem
        .code
          margin-bottom: .9333rem
        img
          width 100%
          height auto
          margin: 1.4933rem 0 1.28rem
        .imgValue
          font-size: .7rem
          line-height: 1.2rem
        .goTop
          display: none
      .contentRight
        display: none
@media screen and (max-width: 700px)
  .yk-listPage
    .banner
      .img
        transform scale(0.6)
        right -25%
@media screen and (max-width: 500px)
  .yk-listPage
    .banner
      .img
        transform scale(0.5)
        right -30%
</style>